import { isString } from '@flowio/is';
export default function resolveContainer(container) {
  return isString(container) ? document.querySelector(container) : container;
}
//# sourceMappingURL=resolve-container.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/utilities/resolve-container.js
// module id = 602
// module chunks = 0 1